<template>
  <i class="iconfont" :class="`icon-${type}`" />
</template>

<script>
export default {
  name: 'Icon',
  props: {
    type: String,
  },
}
</script>

<style>
@import '../../assets/iconfont/iconfont.css';

.iconfont {
  font-size: 1em;
}
</style>
